import { InsightsDashboardPoolState } from '@aytm/app/insights/dashboard/duckness/ducks/types'
import { ColorsModel } from '@aytm/app/insights/dashboard/models/types.ClientDTO'
import { updateCurrentBlock, getCurrentBlock } from './requests'

export type ConfidenceLevelChangePayload = {
  confidenceLevel: number
}

export type SecondaryConfidenceLevelChangePayload = {
  secondaryConfidenceLevel: number
}

export type ShowSigtestChangePayload = {
  show: boolean
}

export type ColorsChangePayload = {
  colors: ColorsModel
}

/**
 * Change confidence level event
 */
export const confidenceLevelChange = (
  state: InsightsDashboardPoolState,
  { confidenceLevel }: ConfidenceLevelChangePayload
) => updateCurrentBlock(state, { confidenceLevel })

/**
 * Change secondary confidence level event
 */
export const secondaryConfidenceLevelChange = (
  state: InsightsDashboardPoolState,
  { secondaryConfidenceLevel }: SecondaryConfidenceLevelChangePayload
) => updateCurrentBlock(state, { secondaryConfidenceLevel })

/**
 * Shows/Hides significance testing
 */
export const showSigtestChange = (state: InsightsDashboardPoolState, { show }: ShowSigtestChangePayload) =>
  updateCurrentBlock(state, { showSigtest: show })

/**
 * Change cell colors for lower/higher than norm data
 */
export const colorsChange = (state: InsightsDashboardPoolState, { colors }: ColorsChangePayload) =>
  updateCurrentBlock(state, { colors })

export const canFetchStatItems = (state: InsightsDashboardPoolState): boolean => {
  const block = getCurrentBlock(state)
  const showSigtest = block?.get<boolean>('showSigtest') || false
  const isLoading = state.isLoading || false
  return showSigtest && !isLoading
}
